import { z } from 'zod';
import { logEntityTypeEnum } from './enums.ts';

/**
 * Maintenance-log wire shape.
 *
 * `cost` is integer cents on the wire — JS floats and money are
 * a bad pairing. Frontend forms do `dollars * 100` on submit and
 * `cents / 100` on render.
 */

export const createLogInput = z.object({
  domainId: z.string().min(1),
  zoneId: z.string().nullable().optional(),
  entityType: logEntityTypeEnum.nullable().optional(),
  entityId: z.string().nullable().optional(),
  performedAt: z.string().min(1),
  title: z.string().min(1).max(200),
  notes: z.string().max(20_000).nullable().optional(),
  cost: z.number().int().nonnegative().nullable().optional(),
  vendorId: z.string().nullable().optional(),
});
export type CreateLogInput = z.infer<typeof createLogInput>;

export const patchLogInput = createLogInput.partial();
export type PatchLogInput = z.infer<typeof patchLogInput>;
